import React from "react";
import Lottie from "lottie-react";
import defaultAnimation from "../../assets/lottie/no-result.json";

const NoData = ({
  title = "No Result Found",
  message = "Please try again with another keywords or maybe use generic term",
  buttonText = "Add",
  onClick = () => {},
  animationData = defaultAnimation,
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-4 gap-4">
      <div className="w-40 h-40 ">
        <Lottie animationData={animationData} loop />
      </div>
      <h2 className="text-xl font-semibold text-blue-900">{title}</h2>
      <p className="text-sm text-textLight w-60">{message}</p>
      {buttonText ? (
        <button
          onClick={onClick}
          className=" px-4 py-2 bg-blue-900 text-white text-sm rounded"
        >
          {buttonText}
        </button>
      ) : ""}
    </div>
  );
};

export default NoData;
